.container {
  position: relative;
  display: inline-block;
}

.overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  border-radius: inherit;
  z-index: 1;
}

.loading {
  animation-name: auraStateIndicatorPulse;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

.disabled {
  z-index: 5;
}

@keyframes auraStateIndicatorPulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
